import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.22 58.45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M36.1 21.95h-1.48v-7.44c0-8-6.51-14.51-14.51-14.51S5.6 6.51 5.6 14.51v7.44H4.12A4.12 4.12 0 0 0 0 26.07v28.27a4.12 4.12 0 0 0 4.12 4.12h31.99a4.12 4.12 0 0 0 4.12-4.12V26.07a4.12 4.12 0 0 0-4.12-4.12Zm-24.66-7.44c0-4.78 3.89-8.67 8.67-8.67s8.67 3.89 8.67 8.67v7.44H11.44z" }, null, -1)
  ]))]))
}
export default { render: render }